module.exports = __webpack_public_path__ + "img/filter_funnel_icon.8bc0ef11.svg";